export const AVALIABLE_ROWS_PER_PAGE = [10, 25, 50, 100];
